import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import {
  Grid2 as Grid,
  Rating,
  Typography,
  Link,
  Paper,
  LinearProgress,
  Button,
} from "@mui/material";
import { Charity, Testimonial } from "../../../shared/types";
import * as consts from "../../../shared/utilities/consts";
import { getTestimonials } from "../../../shared/utilities/actions";

export interface TestimonialsProps {
  charity: Charity;
}

export const Testimonials = ({
  charity,
}: TestimonialsProps): React.JSX.Element | null => {
  const [busy, setBusy] = useState<boolean>(true);
  const [testimonials, setTestimonials] = useState<Testimonial[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      let data = await getTestimonials(charity.ein);
      setTestimonials(data);
      setBusy(false);
    };
    fetchData();
  }, []);

  if (busy) {
    return (
      <Grid size={{ xs: 12 }}>
        <LinearProgress />
      </Grid>
    );
  } else {
    if (
      testimonials &&
      testimonials.filter((item) => {
        return item.message.trim().length > 0;
      }).length > 0
    ) {
      return (
        <Grid size={{ xs: 12 }} container>
          <Grid size={{ xs: 12 }}>
            <Typography
              variant="h4"
              style={{
                textAlign: "center",
                paddingTop: "3px",
                width: "100%",
                lineHeight: "30px",
              }}
            >
              What Awesome People Think About the Work This Charity Does
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }} container spacing={2}>
            <Grid size={{ xs: 12 }}>
              {testimonials
                .filter((item) => {
                  return item.message.trim().length > 0;
                })
                .sort((a, b) => {
                  return a.dateSpent > b.dateSpent ? 1 : 0;
                })
                .map((testimonial, index) => {
                  return (
                    <Paper
                      key={index}
                      sx={{
                        padding: "12px",
                        backgroundColor: "#e9933538",
                        border: "1px solid #fae8d8",
                        borderRadius: "12px",
                        marginTop: "24px",
                        boxShadow: "16px 16px #ff7f3b5e",
                        marginBottom: "32px",
                      }}
                    >
                      {testimonial.message}
                    </Paper>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return null;
    }
  }
};
